export const FORM_CONTACT = {
  name: "",
  email: "",
  message: "",
  website: "",
};
